import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

// Thin progress bar that fills as the user scrolls the page
const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={{
        scaleX,
        transformOrigin: '0% 50%',
      }}
      className="fixed top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#1e3a8a] via-[#3b82f6] to-[#c4a24a] z-[60]"
    />
  );
};

// Custom cursor blob that follows the mouse subtly
export const CursorBlob = () => {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    // Disable on touch devices
    if (typeof window !== 'undefined' && 'ontouchstart' in window) {
      setEnabled(false);
      return;
    }
    const handle = (e) => setPos({ x: e.clientX, y: e.clientY });
    window.addEventListener('mousemove', handle);
    return () => window.removeEventListener('mousemove', handle);
  }, []);

  if (!enabled) return null;

  return (
    <motion.div
      className="fixed pointer-events-none z-[45] w-[380px] h-[380px] rounded-full opacity-40 mix-blend-multiply"
      style={{
        background: 'radial-gradient(circle, rgba(147,197,253,0.6) 0%, rgba(255,255,255,0) 65%)',
        left: pos.x - 190,
        top: pos.y - 190,
      }}
      animate={{ x: 0, y: 0 }}
      transition={{ type: 'spring', damping: 25, stiffness: 200, mass: 0.5 }}
    />
  );
};

export default ScrollProgress;
